import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog"]
  static values = { frameId: { type: String, default: "customer-edit-modal-frame" } }

  connect() {
    this.boundOnFrameRender = this.onFrameRender.bind(this)
    this.boundOnBeforeStreamRender = this.onBeforeStreamRender.bind(this)
    document.addEventListener("turbo:frame-render", this.boundOnFrameRender)
    document.addEventListener("turbo:before-stream-render", this.boundOnBeforeStreamRender)
  }

  disconnect() {
    document.removeEventListener("turbo:frame-render", this.boundOnFrameRender)
    document.removeEventListener("turbo:before-stream-render", this.boundOnBeforeStreamRender)
  }

  onFrameRender(event) {
    if (event.target.id !== this.frameIdValue) return
    if (this.hasDialogTarget) this.dialogTarget.showModal()
  }

  onBeforeStreamRender(event) {
    const stream = event.target
    if (!(stream instanceof Element)) return
    if (stream.getAttribute("target") !== this.frameIdValue) return

    const defaultRender = event.detail.render
    event.detail.render = (currentElement) => {
      defaultRender(currentElement)
      this.reopenDialogFromFrame()
    }
  }

  open(event) {
    const row = event.currentTarget
    const editUrl = row.dataset.editUrl
    if (!editUrl) return

    this.clearErrors()
    Turbo.visit(editUrl, { frame: this.frameIdValue })
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  close() {
    if (this.hasDialogTarget) this.dialogTarget.close()
  }

  clearErrors() {
    // Errors render server-side in the form partial after submit.
  }

  reopenDialogFromFrame() {
    requestAnimationFrame(() => {
      const frame = document.getElementById(this.frameIdValue)
      const dialog = frame?.querySelector("dialog")
      if (dialog && !dialog.open) dialog.showModal()
    })
  }
}
